import React from 'react';
import { useTranslation } from 'react-i18next';

import FormTextField from 'components/FormFields/FormTextField';

import { ForeignIdType } from 'stores/workflowStores/workflowPersonalDataStore/model';

interface Props {
  readOnly?: boolean;
  extData?: boolean; // external data (BT)
  detailUnlock?: boolean;
  prefix: string;
  foreignIdType: string;
}

const PersonalId = (props: Props) => {
  const { t } = useTranslation();
  const label = t(`general_personalId_${props.foreignIdType}`);

  return (
    <>
      {props.foreignIdType === ForeignIdType.PERSONAL && (
        <FormTextField
          name={`${props.prefix}personalNumber`}
          label={label}
          readOnly={props.readOnly || props.extData || props.detailUnlock}
          specificError
          fast={false}
          maxLength={11}
        />
      )}
      {(props.foreignIdType === ForeignIdType.NATIONAL ||
        props.foreignIdType === ForeignIdType.PASSPORT) && (
        <FormTextField
          name={`${props.prefix}foreignId`}
          label={label}
          readOnly={props.readOnly || (props.detailUnlock && props.foreignIdType === ForeignIdType.NATIONAL)}
          specificError
          fast={false}
          tooltipContent={
            props.foreignIdType === ForeignIdType.NATIONAL ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: t('general_personalId_NATIONAL_tooltip', {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            ) : undefined
          }
          maxLength={20}
        />
      )}
      {props.foreignIdType === ForeignIdType.CONCAT && (
        <FormTextField
          name={`${props.prefix}foreignId`}
          label={label}
          value={t('general_personalId_CONCAT_value')}
          disabled
          specificError
          fast={false}
        />
      )}
    </>
  );
};

export default PersonalId;
